(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["handmade-strike-blog"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var all=[];
  try{var el=document.getElementById('lal-data');if(el)all=JSON.parse(el.textContent);}catch(e){}
  var activeTag=null,q='',sort='newest';
  function cap(s){return s.replace(/-/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function filtered(){
    var list=all.slice();
    if(activeTag)list=list.filter(function(a){return a.tags&&a.tags.indexOf(activeTag)>-1;});
    if(q){var lq=q.toLowerCase();list=list.filter(function(a){return a.title.toLowerCase().indexOf(lq)>-1||(a.summary||'').toLowerCase().indexOf(lq)>-1||(a.tags||[]).some(function(t){return t.toLowerCase().indexOf(lq)>-1;});});}
    if(sort==='newest')list.sort(function(a,b){return new Date(b.date)-new Date(a.date);});
    else if(sort==='oldest')list.sort(function(a,b){return new Date(a.date)-new Date(b.date);});
    else list.sort(function(a,b){return a.title.localeCompare(b.title);});
    return list;
  }
  function renderTags(){document.querySelectorAll('.lal-tag').forEach(function(btn){var on=btn.dataset.tag===activeTag;btn.classList.toggle('on',on);btn.setAttribute('aria-pressed',String(on));});}
  function featHtml(a){
    if(!a)return '';
    var img=a.img?'<img class="lal-feat__img" src="'+esc(a.img)+'" alt="'+esc(a.imgAlt)+'" loading="lazy" width="800" height="600"/>' :'';
    var sum=a.summary?'<p class="lal-feat__summary">'+esc(a.summary)+'</p>':'';
    return '<a class="lal-feat" href="'+esc(a.url)+'" aria-label="Read featured post: '+esc(a.title)+'"><div class="lal-feat__img-wrap">'+img+'</div><div class="lal-feat__body"><span class="lal-feat__label" aria-hidden="true">&#9733; Latest post</span><h2 class="lal-feat__title">'+esc(a.title)+'</h2>'+sum+'<div class="lal-feat__meta"><span class="lal-feat__author">'+esc(a.author)+'</span><span aria-hidden="true"> &middot; </span><time datetime="'+esc(a.date)+'">'+esc(a.dateLabel)+'</time></div></div></a>';
  }
  function cardHtml(a){
    var tags=(a.tags||[]).slice(0,3).map(function(t){return '<span class="lal-card__tag">'+esc(cap(t))+'</span>';}).join('');
    var img=a.img?'<img class="lal-card__img" src="'+esc(a.img)+'" alt="'+esc(a.imgAlt)+'" loading="lazy" width="800" height="450"/>':'';
    var sum=a.summary?'<p class="lal-card__summary">'+esc(a.summary)+'</p>':'';
    return '<article><a class="lal-card" href="'+esc(a.url)+'" aria-label="Read: '+esc(a.title)+'"><div class="lal-card__img-wrap">'+img+'</div><div class="lal-card__body">'+(tags?'<div class="lal-card__tags">'+tags+'</div>':'')+'<h2 class="lal-card__title">'+esc(a.title)+'</h2>'+sum+'<div class="lal-card__foot"><div><span class="lal-card__author">'+esc(a.author)+'</span><span aria-hidden="true"> &middot; </span><time datetime="'+esc(a.date)+'">'+esc(a.dateLabel)+'</time></div><span class="lal-card__more" aria-hidden="true">Read &rarr;</span></div></div></a></article>';
  }
  function render(){
    renderTags();
    var list=filtered();
    var meta=document.getElementById('lal-meta');
    var feat=document.getElementById('lal-featured');
    var grid=document.getElementById('lal-grid');
    if(!grid)return;
    if(!list.length){if(feat)feat.innerHTML='';grid.innerHTML='<div class="lal-empty"><h2>No posts found</h2><p>Try a different search or clear the filter.</p></div>';if(meta)meta.textContent='No posts found.';return;}
    var showFeat=!q&&!activeTag;
    if(feat)feat.innerHTML=showFeat?featHtml(list[0]):'';
    var cards=showFeat?list.slice(1):list;
    grid.innerHTML=cards.map(cardHtml).join('');
    if(meta){var c=list.length,t=all.length;meta.textContent=c===t?(c+' post'+(c!==1?'s':'')):'Showing '+c+' of '+t+' posts';}
  }
  function init(){
    var tags=document.getElementById('lal-tags');
    if(tags)tags.addEventListener('click',function(e){var b=e.target.closest('.lal-tag');if(!b)return;activeTag=activeTag===b.dataset.tag?null:b.dataset.tag;render();});
    var si=document.getElementById('lal-search');
    if(si)si.addEventListener('input',function(e){q=e.target.value.trim();render();});
    var so=document.getElementById('lal-sort');
    if(so)so.addEventListener('change',function(e){sort=e.target.value;render();});
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
